module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [(_vm.$p('settings/dynamicDns/address')) ? _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Address')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.dns == '0'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.host),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "host", $$v)
      },
      expression: "getSettingsDynamicDNS.host"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/dynamicDns/provider')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Provider')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.provider),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "provider", $$v)
      },
      expression: "getSettingsDynamicDNS.provider"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Dyn DNS",
      "value": "dyndns"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "NO-IP",
      "value": "noip"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Dynu",
      "value": "dynu"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/username')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsDynamicDNS.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "user", $$v)
      },
      expression: "getSettingsDynamicDNS.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/password')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.dns == '1'),
      expression: "getSettingsAddons.dns == '1'"
    }],
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.password),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "password", $$v)
      },
      expression: "getSettingsDynamicDNS.password"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/ip')) ? _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/dynamicDns/IP')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.dns == '0'
    },
    model: {
      value: (_vm.getSettingsDynamicDNS.ip),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDynamicDNS, "ip", $$v)
      },
      expression: "getSettingsDynamicDNS.ip"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea2cf06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/DynamicDns.vue
// module id = 455
// module chunks = 1